import { createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card-header border-0" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h3", { class: "card-title fw-bolder text-dark" }, "Todo", -1)
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_5 = { class: "svg-icon svg-icon-2" }
const _hoisted_6 = { class: "card-body pt-2" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "form-check form-check-custom form-check-solid mx-5" }, [
  /*#__PURE__*/_createVNode("input", {
    class: "form-check-input",
    type: "checkbox",
    value: ""
  })
], -1)
const _hoisted_8 = { class: "flex-grow-1" }
const _hoisted_9 = {
  href: "#",
  class: "text-gray-800 text-hover-primary fw-bolder fs-6"
}
const _hoisted_10 = { class: "text-muted fw-bold d-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_Dropdown2 = _resolveComponent("Dropdown2")

  return (_openBlock(), _createBlock("div", {
    class: ["card", _ctx.widgetClasses]
  }, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode("div", _hoisted_3, [
        _createVNode("button", _hoisted_4, [
          _createVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Layout/Layout-4-blocks-2.svg" })
          ])
        ]),
        _createVNode(_component_Dropdown2)
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
        return (_openBlock(), _createBlock("div", {
          key: index,
          class: [{ 'mb-8': _ctx.list.length - 1 !== index }, "d-flex align-items-center"]
        }, [
          _createVNode("span", {
            class: ["bullet bullet-vertical h-40px", `bg-${item.color}`]
          }, null, 2),
          _hoisted_7,
          _createVNode("div", _hoisted_8, [
            _createVNode("a", _hoisted_9, _toDisplayString(item.title), 1),
            _createVNode("span", _hoisted_10, _toDisplayString(item.text), 1)
          ]),
          _createVNode("span", {
            class: ["badge fs-8 fw-bolder", `badge-light-${item.color}`]
          }, "New", 2)
        ], 2))
      }), 128))
    ])
  ], 2))
}